module.exports = __webpack_public_path__ + "img/1506986914.70aac310.jpg";